import { ComponentCustomProperties } from "vue";

// Function to copy text to clipboard
export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text); // Using Clipboard API to copy text
    console.log('Text copied to clipboard');
  } catch (err) {
    console.error('Failed to copy text', err);
  }
}

export const safeT = ({
  t,
  category,
  keyName
}: {
  t: ComponentCustomProperties['$t'],
  category: string,
  keyName: string
}) => {

  const translationKey = `views.${category}.${keyName}`;
  try {
    const translation = t(translationKey);
    if (translation.startsWith('@') || translation.endsWith('undefined')) {
      return keyName;
    }
    return translation;
  } catch (error) {
    return keyName
  }
}